import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateHoldingFunds(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
    updateGetUserAllStatu(state, { id, data }) {
      // 变更状态
      state.fund[`UserAllStatu${id}`] = data;
    },
    updateFundProductProfit(state, { id, data }) {
      // 变更状态
      state.fund[`GetFundsProductProfit${id.FundCode}`] = data;
    },
  },
  actions: {
    updateHoldingFunds({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EFTradeApi.GetHoldingFunds', id)
          .then((json) => {
            commit('updateHoldingFunds', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },

    updateFundProductProfit({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EFTradeApi.GetFundsProductProfit', id)
          .then((json) => {
            commit('updateFundProductProfit', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },

    updateGetUserAllStatu({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EFTradeApi.GetUserAllStatu', id)
          .then((json) => {
            commit('updateGetUserAllStatu', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
